const dict = {
  es: {
    "app.name": "Portfolio Familiar",
    "app.tagline": "Gestión inmobiliaria multi-moneda",
    "nav.dashboard": "Dashboard",
    "nav.properties": "Propiedades",
    "nav.transactions": "Movimientos",
    "nav.alerts": "Alertas",
    "nav.reports": "Reportes",
    "nav.users": "Usuarios",
    "nav.audit": "Auditoría",
    "nav.tenants": "Inquilinos",
    "nav.maintenance": "Mantenimiento",
    "nav.providers": "Proveedores",
    "nav.logout": "Cerrar sesión",
    "login.title": "Bienvenido de vuelta",
    "login.subtitle": "Ingresa a tu portfolio familiar",
    "login.email": "Correo electrónico",
    "login.password": "Contraseña",
    "login.submit": "Ingresar",
    "login.demo": "Credenciales de demo",
    "kpi.income": "Ingresos del mes",
    "kpi.expense": "Egresos del mes",
    "kpi.net": "Resultado neto",
    "kpi.occupancy": "Ocupación",
    "kpi.value": "Valor de portfolio",
    "kpi.vs_prev": "vs mes anterior",
    "chart.monthly": "Ingresos vs Egresos (últimos 12 meses)",
    "chart.categories": "Egresos por categoría",
    "chart.country": "Distribución por país",
    "chart.ranking": "Ranking de propiedades",
    "prop.add": "Nueva propiedad",
    "prop.edit": "Editar",
    "prop.delete": "Eliminar",
    "prop.roi": "Rentabilidad",
    "prop.value": "Valor",
    "prop.status": "Estado",
    "prop.occupied": "Ocupada",
    "prop.vacant": "Vacía",
    "prop.maintenance": "Mantenimiento",
    "tx.add": "Nuevo movimiento",
    "tx.income": "Ingreso",
    "tx.expense": "Gasto",
    "tx.date": "Fecha",
    "tx.property": "Propiedad",
    "tx.category": "Categoría",
    "tx.description": "Descripción",
    "tx.amount": "Monto",
    "tx.currency": "Moneda",
    "tx.usd": "USD",
    "tx.filter.all": "Todos",
    "alerts.add": "Nueva alerta",
    "alerts.due": "Vencimiento",
    "alerts.resolved": "Resuelta",
    "alerts.resolve": "Marcar resuelta",
    "alerts.testEmail": "Enviar email de prueba",
    "reports.title": "Reportes",
    "reports.excel": "Exportar Excel",
    "reports.pdf": "Exportar PDF",
    "reports.from": "Desde",
    "reports.to": "Hasta",
    "users.add": "Nuevo usuario",
    "users.role.admin": "Administrador",
    "users.role.editor": "Editor",
    "users.role.viewer": "Consulta",
    "users.role.auditor": "Auditor",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.confirm": "Confirmar",
    "common.loading": "Cargando…",
    "common.name": "Nombre",
    "common.address": "Dirección",
    "common.country": "País",
    "common.city": "Ciudad",
    "common.company": "Empresa titular",
    "common.notes": "Notas",
    "common.photo": "Foto (URL)",
    "common.type": "Tipo",
    "common.severity": "Severidad",
    "common.title": "Título",
    "common.actions": "Acciones",
    "sev.info": "Info",
    "sev.warning": "Advertencia",
    "sev.critical": "Crítica",
    "sev.low": "Baja",
    "sev.med": "Media",
    "sev.high": "Alta",
  },
  en: {
    "app.name": "Family Portfolio",
    "app.tagline": "Multi-currency real estate management",
    "nav.dashboard": "Dashboard",
    "nav.properties": "Properties",
    "nav.transactions": "Transactions",
    "nav.alerts": "Alerts",
    "nav.reports": "Reports",
    "nav.users": "Users",
    "nav.audit": "Audit",
    "nav.tenants": "Tenants",
    "nav.maintenance": "Maintenance",
    "nav.providers": "Providers",
    "nav.logout": "Log out",
    "login.title": "Welcome back",
    "login.subtitle": "Sign in to your family portfolio",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.demo": "Demo credentials",
    "kpi.income": "Income this month",
    "kpi.expense": "Expenses this month",
    "kpi.net": "Net result",
    "kpi.occupancy": "Occupancy",
    "kpi.value": "Portfolio value",
    "kpi.vs_prev": "vs previous month",
    "chart.monthly": "Income vs Expenses (last 12 months)",
    "chart.categories": "Expenses by category",
    "chart.country": "Distribution by country",
    "chart.ranking": "Property ranking",
    "prop.add": "New property",
    "prop.edit": "Edit",
    "prop.delete": "Delete",
    "prop.roi": "Yield",
    "prop.value": "Value",
    "prop.status": "Status",
    "prop.occupied": "Occupied",
    "prop.vacant": "Vacant",
    "prop.maintenance": "Maintenance",
    "tx.add": "New transaction",
    "tx.income": "Income",
    "tx.expense": "Expense",
    "tx.date": "Date",
    "tx.property": "Property",
    "tx.category": "Category",
    "tx.description": "Description",
    "tx.amount": "Amount",
    "tx.currency": "Currency",
    "tx.usd": "USD",
    "tx.filter.all": "All",
    "alerts.add": "New alert",
    "alerts.due": "Due date",
    "alerts.resolved": "Resolved",
    "alerts.resolve": "Mark resolved",
    "alerts.testEmail": "Send test email",
    "reports.title": "Reports",
    "reports.excel": "Export Excel",
    "reports.pdf": "Export PDF",
    "reports.from": "From",
    "reports.to": "To",
    "users.add": "New user",
    "users.role.admin": "Administrator",
    "users.role.editor": "Editor",
    "users.role.viewer": "Viewer",
    "users.role.auditor": "Auditor",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.loading": "Loading…",
    "common.name": "Name",
    "common.address": "Address",
    "common.country": "Country",
    "common.city": "City",
    "common.company": "Owner company",
    "common.notes": "Notes",
    "common.photo": "Photo (URL)",
    "common.type": "Type",
    "common.severity": "Severity",
    "common.title": "Title",
    "common.actions": "Actions",
    "sev.info": "Info",
    "sev.warning": "Warning",
    "sev.critical": "Critical",
    "sev.low": "Low",
    "sev.med": "Medium",
    "sev.high": "High",
  },
};

export function translate(lang, key) {
  return (dict[lang] && dict[lang][key]) || (dict.es[key] || key);
}

export default dict;
